import React from 'react';
import { Link } from 'react-router-dom';
import SingleLineCaption from './dom-elements/SingleLineCaption';
import BgImage from './dom-elements/BgImage';
import { bgImage } from './../scripts';
import { heights, widths, fonts, colors, spacing } from './../styles/theme.json';

function scrollUpRelated() {
  window.scrollTo(0, 0);
}
const RelatedPosts = (props) => {
  const Posts = props.Posts.map((item, i) =>
    <li onClick={() => { scrollUpRelated(); }} className={'post-item'} key={item.new_key + '-' + i}>
      <Link to={'/' + item.link.postType + '/' + item.link.slug}>
        <div className={'post-item-wrapper'} style={bgImage(item.thumbnail.small)} >
        <BgImage source={item.thumbnail.thumb} />
        </div>
        <div className={'caption'}>
          <SingleLineCaption Headline={item.title} Description={item.description} Sep={true} Stacked={false} />
        </div>
      </Link>
      <style jsx>{`
        .post-item {
          padding: 0 1.5rem;
          margin-bottom: 3rem;
          width: 100%;
        }
        @media (min-width: 640px) {
          .post-item {
            margin-bottom: 0;
            width: calc(100% / 3);
          }
        }
        .post-item-wrapper {
          width: 100%;
          height: 0;
          overflow: hidden;
          padding-bottom: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-postion: center;
          position: relative;
        }
        .caption {
          margin-top: 1.5rem;
        }
      `}</style>
    </li>
  );
  return (
    <section id={'related-posts'}>
      <div className={'title'}>
        <h5 className={'title-text'}>RELATED</h5>
      </div>
      <ul id={'posts'}>
        {Posts}
      </ul>
      <style jsx>{`
        #related-posts {
          width: 100vw;
          padding: 0 1.5rem 2rem;
          display: flex;
          align-items: center;
          flex-direction: column;
          background-color: ${colors.grey};
        }
        #posts {
          list-style: none;
          width: 100%;
          //max-width: calc(${widths.global_max_width} + 3rem);
          display: flex;
          flex-direction: column;
        }
        @media (min-width: 640px) {
           #related-posts {
             padding-bottom: 6.5rem;
           }
          #posts {
            flex-direction: row;
          }
        }
        .title {
          padding: 4rem 0;
          display: flex;
          justify-content: center;
        }
        .title-text {
          font-size: 1.8rem;
          font-family: ${fonts.mallory};
          text-transform: uppercase;
          font-weight: bold;
          color: ${colors.black};
        }
      `}</style>
    </section>
  );
};

export default RelatedPosts;



// WEBPACK FOOTER //
// ./src/components/RelatedPosts.js